import { Calendar } from "primereact/calendar";
import "./advancesearchform.scss";
import { useEffect, useState } from "react";
import { areParamsEqual } from "../../../../../utils/globalUtilities";

const AdvanceSearchForm = ({ advanceSearchData, onClickSearch, onClickReset }: any) => {
    const [advanceSearchFormData, setAdvanceSearchFormData] = useState<any>({});

    useEffect(() => {
        if (advanceSearchData) {
            if (!areParamsEqual(advanceSearchData, advanceSearchFormData)) {
                setAdvanceSearchFormData(advanceSearchData)
            }
        }
    }, [advanceSearchData]);
    const isTextFieldsEmpty = !advanceSearchFormData.allOfTheseText?.trim() &&
                          !advanceSearchFormData.exactphraseText?.trim() &&
                          !advanceSearchFormData.anyOfTheseText?.trim();

    return (
        <div className="group-form">
            <div className='group-form-row'>
                <div className='group-form-colls'>
                    <label className='form-label-1'> All of these words 
                        {/* <span className='color-red'>* </span>  */}
                    </label>
                    <input type='text' className='form-control-t1' placeholder='Enter' value={advanceSearchFormData.allOfTheseText}
                        onChange={(e: any) => {
                            setAdvanceSearchFormData({
                                ...advanceSearchFormData,
                                'allOfTheseText': e.target.value,
                            });
                        }}
                    />
                </div>
            </div>
            <div className='group-form-row'>
                <div className='group-form-colls'>
                    <label className='form-label-1'> Exact Phrase 
                        {/* <span className='color-red'>* </span> */}
                    </label>
                    <input type='text' className='form-control-t1' placeholder='Enter' value={advanceSearchFormData.exactphraseText}
                        onChange={(e: any) => {
                            setAdvanceSearchFormData({
                                ...advanceSearchFormData,
                                'exactphraseText': e.target.value,
                            });
                        }}
                    />
                </div>
            </div>

            <div className='group-form-row'>
                <div className='group-form-colls'>
                    <label className='form-label-1'> Any of these words 
                        {/* <span className='color-red'>* </span>  */}
                    </label>
                    <input type='text' className='form-control-t1' placeholder='Enter' value={advanceSearchFormData.anyOfTheseText}
                        onChange={(e: any) => {
                            setAdvanceSearchFormData({
                                ...advanceSearchFormData,
                                'anyOfTheseText': e.target.value,
                            });
                        }}
                    />
                </div>
            </div>
            <div className='group-form-row'>
                <div className='group-form-colls'>
                    <label className='form-label-1'> None of these words 
                        {/* <span className='color-red'>* </span>  */}
                    </label>
                    <input type='text' className='form-control-t1' placeholder='Enter' value={advanceSearchFormData.noneOfTheseText}
                        onChange={(e: any) => {
                            setAdvanceSearchFormData({
                                ...advanceSearchFormData,
                                'noneOfTheseText': e.target.value,
                            });
                        }}
                    />
                </div>
            </div>
            <div className='group-form-row'>
                <div className='group-form-colls'>
                    <label className='form-label-1'> Date Range </label>
                    <div className='group-flex-row'>
                        <div className='group-flex-colls pr-2'>
                            <Calendar value={advanceSearchFormData.dateFrom} dateFormat="dd/mm/yy"
                                showIcon
                                disabled={isTextFieldsEmpty}
                                onChange={(e: any) => {
                                    setAdvanceSearchFormData({
                                        ...advanceSearchFormData,
                                        'dateFrom': e.value,
                                    });
                                }}
                            ></Calendar>
                        </div>
                        <div className='group-flex-colls pl-2'>
                            <Calendar value={advanceSearchFormData.dateTo} dateFormat="dd/mm/yy"
                                showIcon
                                disabled={!advanceSearchFormData.dateFrom} 
                                minDate={advanceSearchFormData.dateFrom || null}
                                onChange={(e: any) => {
                                    setAdvanceSearchFormData({
                                        ...advanceSearchFormData,
                                        'dateTo': e.value,
                                    });
                                }}
                            ></Calendar>
                        </div>
                    </div>
                </div>
            </div>

            <div className='group-form-row'>
                <div className='group-form-colls'>
                    <a  className='button-primary active cursor-pointer' onClick={() => onClickSearch(advanceSearchFormData)} > Search </a>
                    <a  className='button-primary cursor-pointer' onClick={() => onClickReset()} > Reset </a>
                </div>
            </div>




        </div>
    );
};

export default AdvanceSearchForm;
